// Copyright 2026 Hardfin, Inc.
import { MoveUpload } from '@/asset/components/move-upload/move-upload';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function MoveImportDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="lg" open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>Import moves</DialogTitle>
      <DialogContent dividers>
        <MoveUpload onClose={props.onClose} />
      </DialogContent>
    </Dialog>
  );
}
